const APIs = {
  PUBLICATIONS: 'admin/publications',
  SINGLE_PUBLICATION: 'admin/publications/:id',
  PERFORM_ACTION_PUBLICATION: 'admin/publications/:id/perform-action',
  TRENDING_PUBLICATIONS: 'publications/trending',
}

export default APIs
